import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo/Logo";
import { CONTACTS } from "@/constants/contacts";

const LINKS = [
  { to: "/como-funciona", label: "Como funciona" },
  { to: "/para-clinicas", label: "Para clínicas" },
  { to: "/tecnologia", label: "Tecnologia" },
  { to: "/sobre", label: "Sobre" },
  { to: "/blog", label: "Blog" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  return (
    <>
      <nav
        className={`navbar ${scrolled || mobileOpen ? "navbar-scrolled" : ""}`}
        data-testid="navbar"
      >
        <div className="container navbar-inner">
          <Link to="/" data-testid="navbar-logo-link" aria-label="Akali AI — início">
            <Logo size={32} variant="default" />
          </Link>

          <div className="navbar-links">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `navbar-link ${isActive ? "active" : ""}`
                }
                data-testid={`navbar-link-${l.to.replace("/", "")}`}
              >
                {l.label}
              </NavLink>
            ))}
          </div>

          <div className="navbar-cta">
            <a
              href={CONTACTS.app}
              className="navbar-ghost-btn"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="navbar-access-app"
            >
              Acessar app <ArrowUpRight size={14} />
            </a>
            <a
              href={CONTACTS.app + "/signup"}
              className="navbar-cta-btn"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="navbar-signup-cta"
            >
              Começar grátis
            </a>
          </div>

          <button
            className="navbar-hamburger"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label={mobileOpen ? "Fechar menu" : "Abrir menu"}
            data-testid="navbar-hamburger"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="mobile-menu" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className="mobile-menu-link"
              data-testid={`mobile-menu-link-${l.to.replace("/", "")}`}
            >
              {l.label}
            </NavLink>
          ))}
          <div className="mobile-menu-cta">
            <a
              href={CONTACTS.app}
              className="btn btn-ghost btn-full"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-menu-access-app"
            >
              Acessar app <ArrowUpRight size={16} />
            </a>
            <a
              href={CONTACTS.app + "/signup"}
              className="btn btn-primary btn-full"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-menu-signup"
            >
              Começar grátis
            </a>
          </div>
        </div>
      )}
    </>
  );
}
